import { createInterfaceId } from "@gitlab/needle";
//#region src/sandbox_availability_service.ts
const SandboxAvailabilityService = createInterfaceId("SandboxAvailabilityService");
//#endregion
export { SandboxAvailabilityService as t };

//# sourceMappingURL=sandbox_availability_service-D9qa9DsC.mjs.map